import React, { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

type InfoBlockOrderedListItemProps = { children?: ReactNode; wrapperClassName?: string } & {
  [key: string]: unknown
}

export const InfoBlockOrderedListItem = ({
  children,
  wrapperClassName,
  ...props
}: InfoBlockOrderedListItemProps) => {
  return (
    <li
      className={twMerge(
        `counter-increment before:bg-fill-primary
      flex
      gap-4
      before:h-6 before:w-6 before:shrink-0 before:rounded-[50%]
      before:text-center before:text-[16px] before:text-sm
      before:leading-6 before:content-[counter(counter)]
      `,
        wrapperClassName,
      )}
    >
      <span {...props}>{children}</span>
    </li>
  )
}
